import React, { useState } from "react";

// material components
import { TablePagination, Typography } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import Table from '@material-ui/core/Table';
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import GlobalTableHead from "../../global/Table/GlobalTableHead";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FilterIcon from "../../shipments/FilterIcon";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { Slide } from "@material-ui/core";

// custom components
import SearchableTable from "../../global/Search/SearchableTable";
import ExpandedCustomerPurchaseOrder from "./ExpandedCustomerPurchaseOrder";

// constants
import { LIST_PURCHASE_ORDERS_CELLS, ROW_KEYS, ROWS_PER_PAGE_LABEL, STATUS, FILTER } from "./constants";
import { ASC, DESC } from "../../global/constants";
import { DEFAULT_ROWS_PER_PAGE, DEFAULT_SORT_BY_HEAD_CELL, } from "./constants";


// styling
import "./PurchaseCustomerOrdersTable.css"
import PropTypes from "prop-types";
import TableFooter from "@material-ui/core/TableFooter";
import SearchField from "../../global/Search/SearchField";
import CustomTableHeader from "../../global/Table/CustomTableHeader";
import RenderPurchaseOrderPDFPreview from "./RenderPurchaseOrderPDFPreview";
import PurchaseCustomerOrderDetails from "./PurchaseCustomerOrderDetails";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import PurchaseCustomerOrderFiltersDialog from "./PurchaseCustomerOrderFiltersDialog";
import FilterTagsBar from "../../shipments/FilterTagsBar";
import LocationSelectBox from "../../global/subcomponents/locationSelectBox/LocationSelectBox";

class PurchaseCustomerOrdersTable extends SearchableTable {
    constructor(props) {
        super(props);
        this.state = {
            order: DESC,
            orderBy: DEFAULT_SORT_BY_HEAD_CELL,
            selectedOrder: [],
            isSearch: false,
            searchValue: '',
            searchRows: 0,
            isFilterApplied: false,
            filtersMapBeforeOpenDialog: {},
            selectedStatus:  [
                "open",
                "cancelled",
                "partial",
                "completed"
            ],
            dropdownAll: false,
            filtersOpen: false,
            fromDate: this.getFromDate(),
            toDate: this.getToDate(),
            filtersMap: {},
            deletedTagsWithCookies: [],
            filterShipAddressId : this.props.userInfo.selectedLocationId,
            deleteId: "",
            showFilters: false,
        };
    }

    async componentDidMount() {
        let changeBack = false
        await this.setState({
            searchValue: this.props.searchText,
            filtersMap: this.props.tableSetting?.customerOrderFilterSetting,
            selectedStatus: this.props.tableSetting?.customerOrderFilterSetting?.selectedStatus ?? []
        })
        if (this.props.rows.length > 0) return
        let storage = JSON.parse(localStorage.getItem("customerPurchaseOrders"))
        if (storage) {
            this.getNewDates()
            const expiry = parseInt(JSON.parse(localStorage.getItem("expiry")))
            if (storage.fromDate !== null && storage.fromDate !== undefined) {
                if (expiry > new Date().getTime()) {
                    this.onFiltersClose(true, false)
                } else {
                    changeBack = true
                }
            }
            else if (storage.toDate !== null && storage.toDate !== undefined) {
                if (expiry > new Date().getTime()) {
                    this.onFiltersClose(true, false)
                } else {
                    changeBack = true
                }
            }
            if (changeBack) {
                localStorage.removeItem("customerPurchaseOrders")
                this.setState({
                    fromDate: this.getFromDate(),
                    toDate: this.getToDate(),
                    filtersMap: {}
                })
            }
        }

    }

    componentDidUpdate(prevProps) {
        // if (prevProps.tableSetting !== this.props.tableSetting) {
        //     this.setState({ selectedStatus: this.props.tableSetting?.customerOrderFilterSetting?.selectedStatus ?? [] })
        // }


           if (prevProps.tableSetting?.customerOrderFilterSetting !== this.props.tableSetting?.customerOrderFilterSetting) {
               this.setState({
                   filtersMap: this.addFilterDates(this.props.tableSetting?.customerOrderFilterSetting),
                   selectedStatus: this.props.tableSetting?.customerOrderFilterSetting?.selectedStatus ?? []
               })
           }

        if (prevProps.searchText !== this.props.searchText) {
            this.setState({ searchValue: this.props.searchText })
        }
    }

    addFilterDates = (filters) => {
        if (filters) {
            if (!this.isDefaultFromDate(this.state.fromDate)) {
                filters['fromDate'] = this.state.fromDate
            }
            if (!this.isToday(this.state.toDate)) {
                filters['toDate'] = this.state.toDate
            }
        }
        return filters
    }

    getFromDate = () => {
        var date = new Date()
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setDate(date.getDate() - 14)
        return date;
    }

    getToDate = () => {
        var date = new Date()
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        return date;
    }

    updateDeleteId = (deleteId) =>{
        this.setState({ deleteId:  deleteId})
    }

    handleDelete = () => {
       this.props.deleteOrder({ poNumber: this.state.deleteId }, () => window.location.reload())
       this.setState({ deleteId: "" })
    }

    isDefaultFromDate = (someDate) => {
        const defaultFromDate = this.getFromDate()
        return someDate.getDate() === defaultFromDate.getDate() &&
            someDate.getMonth() === defaultFromDate.getMonth() &&
            someDate.getFullYear() === defaultFromDate.getFullYear()
    }

    getNewDates = () => {
        let filter = {...this.state.filtersMap}
        let storage = JSON.parse(localStorage?.getItem("customerPurchaseOrders"))
        if (storage.fromDate !== null && storage.fromDate !== undefined ) {
            const temp = new Date(storage.fromDate)
            filter.fromDate = temp;
            this.setState({
                fromDate: temp
            })
        }
        if (storage.toDate !== null && storage.toDate !== undefined) {
            const temp = new Date(storage.toDate)
            filter.toDate = temp;
            this.setState({
                toDate: temp
            })
        }

        if (filter) {
            this.setState({
                filtersMap: filter,
            })
        }
    }

    isToday = (someDate) => {
        const today = new Date()
        return someDate.getDate() === today.getDate() &&
            someDate.getMonth() === today.getMonth() &&
            someDate.getFullYear() === today.getFullYear()
    }

    handleChangePage = (event, newPage) => {
        this.props.setPage(newPage)
    };

    handleChangeRowsPerPage = (event) => {
        this.props.setRowsPerPage(event.target.value)
        this.props.setPage(0)
    };


    getDisplayed = (rows) => {
        if (!rows)
            return [];
        return [...rows.slice(this.props.page * this.props.rowsPerPage, this.props.page * this.props.rowsPerPage + this.props.rowsPerPage)];
    }

    onSearchValueChange = (event) => {
        this.setState({
            isSearch: event.target.value.length > 0,
            searchValue: event.target.value
        });
        this.props.setPage(0)
        this.props.handleSearchTextChange(event)
    }

    handleDenseChange = (event) => {
        this.setState({
            dense: event.target.checked,
        });
    }


    handleStatusChange = (event) => {
        let filters = { ...this.state.filtersMap };
        let checked = event.target.checked
        let name = event.target.name
        let statuses = []
        if (checked) {
            statuses = [...this.state.selectedStatus, name]
            this.setState({
                selectedStatus: statuses
            });
        }
        // remove from the list
        else {
            let index = this.state.selectedStatus.indexOf(name)
            let selected = this.state.selectedStatus
            selected.splice(index, 1)
            statuses = selected
            this.setState({
                selectedStatus: selected ?? []
            });
        }
        filters.selectedStatus = statuses
        this.saveUpdatedStatus(filters);
        //this.props.setSelected(checked, true)
        // this.onFiltersInputChange(event);
    }

    onFiltersInputChange = (name, val) => {
        const filtersMap = { ...this.state.filtersMap };

        // if filter already exists, then update
        if (val !== "" && val.length !== 0) {
            filtersMap[name] = val;
        }
        else {
            delete filtersMap[name];
        }

        this.saveUpdatedStatus(filtersMap)

        this.setState({
            filtersMap: filtersMap,
        });

    }

    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === ASC;
        this.setState({
            order: isAsc ? DESC : ASC,
            orderBy: property,
        });
    };

    handleSelectAllClick = () => {
        const isDropdownAll = !this.state.dropdownAll
        this.setState({
            dropdownAll: isDropdownAll
        })
    }
    fetchCreatedPurchaseOrderPreview = (purchaseOrderDate) => {
        this.props.storeCreatedPurchaseOrderPreview([])
        this.props.previewCreatedPurchaseOrder(purchaseOrderDate)
        this.props.updateField("previewing", true)
        this.props.updateField("previewingName", purchaseOrderDate)
        this.props.updateHasPurchaseOrderEmailTemplate(purchaseOrderDate)
        this.setState({
            showingPurchaseOrder: purchaseOrderDate
        })
    }

    getFilteredPurchaseOrderLength = (purchaseOrderList) => {
        if (this.state.selectedStatus) {
            return purchaseOrderList.filter((item) => this.state.selectedStatus.includes(item.status)).length
        }
        return 0;
    }

    getStatusFilteredPurchaseOrders = (purchaseOrderList) => {
        if (this.state.selectedStatus) {
            return purchaseOrderList.filter((item) => this.state.selectedStatus.includes(item.status))
        }
        return [];
    }

    toggleFiltersDialog = () => {
        this.setState({
            showFilters: !this.state.showFilters,
            filtersMapBeforeOpenDialog: { ...this.state.filtersMap }
        })
    }



    applyOverviewFilters = (rows) => {
        if (this.state.selectedStatus) {
            rows = rows.filter((item) => this.state.selectedStatus.includes(item.status))
        }
        const customer = this.state.filtersMap?.customer;
        if (customer) {
            rows = rows.filter(row => {
                return this.state.filtersMap?.customer.includes(row.customer?.[0]?.name)
            })
        }
        // filter for location
        rows = rows.filter(row => {
            return row.toShipAddressId == this.state.filterShipAddressId
        })
        return rows;
    }


    onFiltersClose = (applyFilters, saveFilterSetting) => {
        // NOTE: changes are already applied as the user makes these changes,
        // but if the changes are cancelled, then the map is reverted to its
        // previous state
        this.setState({
            showFilters: false,
        })
        let filters = {}
        if (!applyFilters) {
            filters = { ...this.state.filtersMapBeforeOpenDialog }
            this.resetDateFilters(filters?.fromDate ?? this.getFromDate(), filters?.toDate ?? this.getToDate(), filters)
        } else {
            if (this.state.deletedTagsWithCookies.length > 0) {
                let storage = JSON.parse(localStorage.getItem("customerPurchaseOrders"))
                this.state.deletedTagsWithCookies.forEach((tagName) => {
                    delete storage[tagName]
                })
                localStorage.setItem("customerPurchaseOrders", JSON.stringify(storage))
                if(JSON.stringify(storage) == JSON.stringify({})) localStorage.removeItem("customerPurchaseOrders")
                this.setState({deletedTagsWithCookies: []})
            }
            filters = { ...this.state.filtersMap }
            const expiry = new Date().setHours(23, 59, 59, 0);
            let isRefetch = this.props.refetch
            if (filters.fromDate !== null && filters.fromDate !== undefined) {
                let existing = localStorage.getItem("customerPurchaseOrders")
                existing = existing ? JSON.parse(existing) : {};
                if(existing.fromDate!==filters?.fromDate) {
                    isRefetch = true
                }
                existing.fromDate = filters.fromDate;
                localStorage.setItem("customerPurchaseOrders", JSON.stringify(existing));
                localStorage.setItem("expiry", JSON.stringify(expiry))
            }
            if (filters.toDate !== null && filters.toDate !== undefined) {
                let existing = localStorage.getItem("customerPurchaseOrders")
                existing = existing ? JSON.parse(existing) : {};
                if(existing.toDate!==filters.toDate) {
                    isRefetch = true
                }
                existing.toDate = filters.toDate;
                localStorage.setItem("customerPurchaseOrders", JSON.stringify(existing));
                localStorage.setItem("expiry", JSON.stringify(expiry))
            }
            if (this.props.rows.length===0||isRefetch) {
                this.props.fetchAllPurchaseOrders({
                    fromDate: this.state.fromDate,
                    toDate: this.state.toDate
                })
                this.props.setRefetch(false)
            }
        }
        if (saveFilterSetting) {
            this.saveUpdatedStatus(filters)
        }
    }



    clearFiltersMap = () => {
        this.setState({
            dateFiltersMap: {},
            fromDate: this.getFromDate(),
            toDate: this.getToDate()
        })
    }

    resetDateFilters = (fromDate, toDate) => {
        let filtersMapClone = { ...this.state.dateFiltersMap }
        if (!this.isDefaultFromDate(fromDate)) {
            filtersMapClone['fromDate'] = fromDate
        }
        if (!this.isToday(toDate)) {
            filtersMapClone['toDate'] = toDate
        }
        this.setState({
            fromDate: fromDate,
            toDate: toDate,
            dateFiltersMap: filtersMapClone,
            deletedTagsWithCookies: [],
        })
    }

    onTagClickedWhenDialogueOpen = (event, tag) => {
        const filtersMap = { ...this.state.filtersMap };
        let tagValue = filtersMap[tag]
        let deletedTagsWithCookies = this.state.deletedTagsWithCookies
        delete filtersMap[tag];
        if (tag === 'fromDate') {
            let storage = JSON.parse(localStorage.getItem('customerPurchaseOrders'))
            if (storage) {
                if (storage.fromDate !== null && storage.fromDate !== undefined) {
                    if (new Date(storage.fromDate).getTime() === new Date(tagValue).getTime()) {
                        this.setState({deletedTagsWithCookies: [...deletedTagsWithCookies, "fromDate"]})
                    }
                }
            }
            this.setState({
                fromDate: this.getFromDate()
            })
        }
        if (tag === 'toDate') {
            let storage = JSON.parse(localStorage.getItem('customerPurchaseOrders'))
            if (storage) {
                if (storage.toDate !== null && storage.toDate !== undefined) {
                    if (new Date(storage.toDate).getTime() === new Date(tagValue).getTime()) {
                        this.setState({deletedTagsWithCookies: [...deletedTagsWithCookies, "toDate"]})
                    }
                }
            }
            this.setState({
                toDate: this.getToDate()
            })
        }
        this.saveUpdatedStatus(filtersMap)
        this.setState({
            filtersMap: filtersMap,
        });
    }

    onTagClicked = (event, tag) => {

        // remove the key from the filters map
        // clone the map, delete the key, set the state
        const filtersMap = { ...this.state.filtersMap };
        delete filtersMap[tag];
        if (tag === 'fromDate') {
            let storage = JSON.parse(localStorage.getItem('customerPurchaseOrders'))
            delete storage.fromDate
            this.setState({
                fromDate: this.getFromDate()
            }, () => this.applyDateFilters(this.state.fromDate, this.state.toDate))
            localStorage.setItem("customerPurchaseOrders", JSON.stringify(storage))
            if(JSON.stringify(storage) == JSON.stringify({})) localStorage.removeItem("customerPurchaseOrders")
        }
        if (tag === 'toDate') {
            let storage = JSON.parse(localStorage.getItem('customerPurchaseOrders'))
            delete storage.toDate
            this.setState({
                toDate: this.getToDate()
            }, () => this.applyDateFilters(this.state.fromDate, this.state.toDate))
            localStorage.setItem("customerPurchaseOrders", JSON.stringify(storage))
            if(JSON.stringify(storage) == JSON.stringify({})) localStorage.removeItem("customerPurchaseOrders")
        }

        this.saveUpdatedStatus(filtersMap)
        this.setState({
            filtersMap: filtersMap,
        });
    }


    handleDateChange = (key, date) => {
        const filtersMap = { ...this.state.filtersMap };
        if (key === 'fromDate' && !this.isDefaultFromDate(date) ||
          key === 'toDate' && !this.isToday(date)) {
            filtersMap[key] = date;
        } else {
            delete filtersMap[key]
        }
        this.setState({
            filtersMap: filtersMap,
            [key]: date
        })
        this.props.handleDateChange(date, key)
    }

    applyDateFilters = (fromDate, toDate) => {
        this.props.fetchAllPurchaseOrders({
            fromDate,
            toDate
        })
    }

    saveUpdatedStatus = (filters) => {
        delete filters['fromDate']
        delete filters['toDate']
        this.props.saveTableSetting({
            userId: this.props.userInfo.userId,
            tableSetting: null,
            changeFilters: false,
            changeCustomerOrderFilters: true,
            customerOrderFilterSetting: filters ?? []
        })
    }
    handleLocationChange = (location) => {
        this.setState({
            filterShipAddressId: location.shipAddressId
        })
    }

    removeStatusFilters = () => {
        let filters = { ...this.state.filtersMap }
        delete filters['selectedStatus']
        return filters
    }

    render() {

        return (
            <>
                {this.props.previewing &&
                    <RenderPurchaseOrderPDFPreview
                        //allowSave={true}
                        data={this.props.pdfData}
                        //handlePreviewOpen={this.handlePreviewOpen}
                        //handlePreviewClose={this.handlePreviewClose}
                        //open={this.state.previewOpen}
                        handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
                        handlePdfLoadError={this.props.handlePdfLoadError}
                        pdfLoadSuccess={this.props.pdfLoadSuccess}
                        scale={this.props.scale}
                    /> ||
                    <>
                        <FilterTagsBar
                          filtersMap={this.removeStatusFilters()}
                          onClick={this.state.showFilters ? this.onTagClickedWhenDialogueOpen : this.onTagClicked}
                        />
                        <CustomTableHeader
                            isPurchaseOrderTable={true}
                            searchText={this.props.searchText}
                            onSearchValueChange={this.onSearchValueChange}
                            location={
                                <LocationSelectBox
                                    selectedLocationId={this.state.filterShipAddressId}
                                    updateCallback={this.handleLocationChange}
                                />
                            }
                            filterIcon={
                                <Tooltip title={FILTER} style={{ paddingTop: 10 }}>
                                    <IconButton className="filterButton" size='small' aria-label={FILTER} onClick={this.toggleFiltersDialog} >
                                        <FilterIcon />
                                    </IconButton>
                                </Tooltip>
                            }
                            showFilters={this.state.showFilters}
                            filtersComponent={
                                <Slide in={this.state.showFilters} mountOnEnter unmountOnExit timeout={300}>
                                    <PurchaseCustomerOrderFiltersDialog
                                      open={this.state.showFilters}
                                      onClose={this.onFiltersClose}
                                      onChange={this.onFiltersInputChange}
                                      listItems={this.props.customers}
                                      handleDateChange={this.handleDateChange}
                                      filtersMap={this.state.filtersMap}
                                      clearFilters={this.clearFiltersMap}
                                      onTagClicked={this.onTagClicked}
                                      fromDate={this.state.fromDate}
                                      toDate={this.state.toDate}
                                      fieldName={'customer'}
                                      fieldTitle={'Customer'}
                                    />
                                </Slide>}
                            customFilterField={
                                <>
                                    <div className="filters">
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.selectedStatus ? this.state.selectedStatus.includes('open') : false}
                                                onChange={this.handleStatusChange} name="open"
                                                style={{ color: '#acd685' }} />}
                                            label="Open"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.selectedStatus ? this.state.selectedStatus.includes('partial') : false}
                                                onChange={this.handleStatusChange} name="partial"
                                                style={{ color: '#acd685' }} />}
                                            label="Partial"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.selectedStatus ? this.state.selectedStatus.includes('completed') : false}
                                                onChange={this.handleStatusChange} name="completed"
                                                style={{ color: '#acd685' }} />}
                                            label="Completed"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.selectedStatus ? this.state.selectedStatus.includes('cancelled') : false}
                                                onChange={this.handleStatusChange} name="cancelled"
                                                style={{ color: '#acd685' }} />}
                                            label="Cancelled"
                                        />
                                    </div>

                                </>
                            }
                            pagination={
                                <TablePagination
                                    className="table-pagination"
                                    labelRowsPerPage={ROWS_PER_PAGE_LABEL}
                                    rowsPerPageOptions={[5, 25, 50, 100, {value: this.props.rows.filter(row => row.toShipAddressId === this.state.filterShipAddressId).length, label: "All"} ]}
                                    count={this.filterBySearch(this.applyOverviewFilters(this.props.rows)).length}
                                    rowsPerPage={this.props.rowsPerPage}
                                    page={this.props.page}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            }
                        />

                        <TableContainer>
                            <Table
                                aria-labelledby="tableTitle"
                                size={'medium'}
                                aria-label={this.props.title}
                            >
                                <GlobalTableHead
                                    isCreatePurchaseOrderTable={false}
                                    isShipmentTable={false}
                                    isPurchaseOrderTable={true}
                                    headCells={LIST_PURCHASE_ORDERS_CELLS}
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={!this.props.rows.filter(row => row.toShipAddressId === this.state.filterShipAddressId) ? 0 : this.props.rows.filter(row => row.toShipAddressId === this.state.filterShipAddressId).length}
                                    onSelectAllClick={this.handleSelectAllClick}
                                />
                                <TableBody>
                                    { this.getDisplayed(this.stableSort(this.filterBySearch(this.applyOverviewFilters(this.props.rows)), this.getComparator(this.state.order, this.state.orderBy))).map((row, index) => {


                                        // {this.getDisplayed(this.stableSort(this.getStatusFilteredPurchaseOrders(this.filterBySearchWithSpecificKeys(this.props.rows.filter(row => row.toShipAddressId === this.state.filterShipAddressId), ROW_KEYS)),
                                        // this.getComparator(this.state.order, this.state.orderBy))).map((row, index) => {
                                            return (
                                                <>
                                                    <ExpandedCustomerPurchaseOrder
                                                        purchaseOrder={row}
                                                        fetchCreatedPurchaseOrderPreview={this.fetchCreatedPurchaseOrderPreview}
                                                        //changeHeader={this.props.changeHeader}
                                                        onReceivedChange={this.props.onReceivedChange}
                                                        updatePurchaseOrder={this.props.updatePurchaseOrder}
                                                        deleteInventoryReceived={this.props.deleteInventoryReceived}
                                                        key={row.poNumber}
                                                        showDropdown={this.state.dropdownAll}
                                                        editingPo={this.props.editingPO}
                                                        handleEditPo={this.props.handleEditPo}
                                                        handleDelete={this.handleDelete}
                                                        updateDeleteId={this.updateDeleteId}
                                                        deleteId={this.state.deleteId}
                                                    />
                                                </>
                                            );
                                        })
                                    }
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </>}
            </>
        )
    }


}

PurchaseCustomerOrdersTable.propTypes = {
    updatePurchaseOrder: PropTypes.func,
    deleteInventoryReceived: PropTypes.func,
    rows: PropTypes.array
}

PurchaseCustomerOrdersTable.defaultProps = {
    updatePurchaseOrder: () => {
    },
    deleteInventoryReceived: () => {
    },
    rows: []
}


export default PurchaseCustomerOrdersTable;